<template>
  <div ref="frisbuy-widget-gallery" :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}" :style="[galleryStyle]">
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div class="frisbuy-title" v-if="headerSettings.title || headerSettings.buttonTitle">
        {{headerSettings.title}}<a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">{{headerSettings.buttonTitle}}</a>
      </div>
      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle" :style="[subTitleStyle]">{{headerSettings.subTitle}}</div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)">{{filter.name}}</a>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe.stop="swipeHandler"
        ref="postsScroll"
        >
        <div :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }">
          <ul
            class="frisbuy-gallery-posts"
            id="frisbuy-gallery-posts"
            :class="{ 'frisbuy-gallery-multiline': isLineRowsMode, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
            :style="{ margin: `-${ containerItemMargin / 2}px`, width: `calc(100% + ${ containerItemMargin }px)`, maxHeight: !isVerticalGallery && isLineRowsMode && containerRowsHeight }"
          >
            <template v-for="(post, index) in postList">
              <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li>
              <template v-if="post.frisbuyPost.type === 'advertising'"></template>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{width: getPostItemWidth(index), margin: `${ containerItemMargin / 2 }px` }"
                :observer="imageObserver"
                @click.native="clickPostHandler(post, index)"
                >
              </post-item>
            </template>
          </ul>
        </div>
      </div>

      <!-- <frisbuy-gallery-pagination
        v-if="isShowPagination"
        :itemsCount="countOfPages"
        :currentItemIdx="currentPage"
        @navigateTo="(idx) => galleryScrollTo(idx)"
      /> -->

      <div v-if="gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)" :class="{ 'frisbuy-gallery-navigation': true, 'frisbuy-big': isLineRowsMode }">
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canPrevScroll}" @click="slideHandler(-1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
          </svg>
        </div>
        <span></span>
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canNextScroll}" @click="slideHandler(1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
          </svg>
        </div>
      </div>
    </div>
    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy">
      </a>
    </div>
    <div class="frisbuy-footer">
      <div :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}" class="frisbuy-loadmore-button" v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show" @click="loadMoreHandler">{{ gallerySettings.loadMore.text || 'Ещё' }}</div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
    </div>
    <div v-if="gallerySettings.guideline.html && isGuidlineOpen" class="frisbuy-guideline">
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style scoped src="./gallery.scss" lang="scss"></style>
<style lang="scss">
.frisbuy-widget {
  .frisbuy-gallery-posts .frisbuy-gallery-post {
    border-radius: 16px;

    &.frisbuy-video {
      .frisbuy-post-image::before {
        background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjUiIGN5PSIyNSIgcj0iMjQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjYiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIyNSIgY3k9IjI1IiByPSIyMiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzcwOTNfMzk3KSIvPgo8cGF0aCBkPSJNMjEgMzJWMThMMzEgMjVMMjEgMzJaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49ImJldmVsIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNzA5M18zOTciIHgxPSI1LjgyMzUzIiB5MT0iMS45MjM1NSIgeDI9IjE5Ljc3ODYiIHkyPSI1NC4xNzEyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAuNSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAuMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=");
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 34px;
        height: 34px;
        max-width: unset;
        max-height: unset;

        opacity: 1;

        @media screen and (min-width: 768px) {
          width: 48px;
          height: 48px;
        }
      }
    }

    .frisbuy-post-cover {
      display: flex;
      justify-content: flex-end;
      align-items: normal;

      &, & > *{
        font-family: inherit;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: -0.02em;
        text-align: left;

        color: #ffffff;
      }

      // .frisbuy-post-cover-name {
      // }

      .frisbuy-post-cover-social {
        margin-top: 0.9em;

        .frisbuy-gallery-post .frisbuy-post-cover-social > div

        div {
          &:not(:last-child) {
            margin-right: 10px;
          }

          img {
            height: 12px;

            margin-right: 6px;
          }
        }
      }

      .frisbuy-post-cover-logo {
        display: none;
      }
    }
  }

  .frisbuy-gallery-navigation {
    top: 50%;

    .frisbuy-navigation-button {
      width: 40px;
      height: 40px;

      background: linear-gradient(
        165.05deg,
        rgba(255, 255, 255, 0.5) -0.58%,
        rgba(255, 255, 255, 0.2) 99.82%
      );
      box-shadow: 0px 1px 24px -1px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);

      transform: translateY(-50%);

      opacity: 1;

      svg:not(.frisbuy-popup .frisbuy-navigation-button svg) polyline {
        color: #252b2e;
      }

      &.frisbuy-navigation-button-disabled {
        opacity: 0;
      }
    }
  }
}
</style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from '../popup/popup.vue';
/* NOTE:
  Sonata's configs
*/

// NOTE: main page gallery
// c6c1b29e-e2e0-40c3-b3dc-39b9d638b9a8
/*
username=fortest&count=12&mode=line&scroll_style=arrow&cols=5&cols_min=2&spacing=12&auto_load_more=&preview=0&disable_stub=1&load_more=&load_more_spacing=&widget_id=8519&load_more_text=Еще&max_width=1350&min_width=452&show_report_button=1&html_title_block=<style>
.frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post,
.frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post .frisbuy-post-image > div {
  aspect-ratio: 9 / 16;
}
.frisbuy-gallery-post .frisbuy-post-image {
  height: 100%;
  padding-bottom: calc(100% * (16 / 9));
}

.frisbuy-navigation-button {
  margin: 0 4px;
}

@media (min-width: 1366px) {
  .frisbuy-navigation-button {
    margin: 0 -2px;
  }
}
</style>
*/
// e659670f-759c-4cad-88a0-73de13def85e (client)
/*
theme=kiko&username=kikocosmetics&count=12&mode=line&scroll_style=arrow&cols=5&cols_min=2&spacing=12&auto_load_more=&preview=0&disable_stub=1&load_more=&load_more_spacing=&widget_id=9087&load_more_text=Еще&max_width=1350&min_width=452&show_report_button=1&hide_sold_out_skus=1&hide_sold_out_sku_posts=1&branding_top=0&full_size_pic=0&html_title_block=<div class="frisbuy_title_block">
    <h1>Kiko Milano</h1>
    <h2>В социальных сетях</h2>
    <h5>
        Делитесь своими образами в соцсетях, отмечайте
        <span>@kikomilanorussia</span>
        и мы разместим ваше фото на сайте!
    </h5>
</div>

<style>
.frisbuy-header {
    margin-bottom: 40px !important;
}
.frisbuy_title_block {
    color: #252B2E;
    font-family:  inherit;
    line-height: 110%;

    align-items: center;
    text-align: center;
    letter-spacing: -0.03em;
}
.frisbuy_title_block h1, .frisbuy_title_block h2 {
    font-size: 40px;
    text-transform: uppercase;
}
.frisbuy_title_block h1 {
    font-weight: 600;
}
.frisbuy_title_block h2 {
    font-weight: 300;
}
.frisbuy_title_block h5 {
    font-weight: 400;
    font-size: 16px;

    margin: 24px 0 0 0;
}
.frisbuy_title_block h5 span {
    color: #d63868;
}

.frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post,
.frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post .frisbuy-post-image > div {
  aspect-ratio: 9 / 16;
}
.frisbuy-gallery-post .frisbuy-post-image {
  height: 100%;
  padding-bottom: calc(100% * (16 / 9));
}

.frisbuy-navigation-button {
  margin: 0 4px;
}

@media (min-width: 1366px) {
  .frisbuy-navigation-button {
    margin: 0 -2px;
  }
}
</style>&html_footer_block=<div class="frisbuy-footer_button-wrapper">
    <button class="frisbuy-button more">
        <a href="https://kikocosmetics.ru/social-wall/">
            Смотреть ещё
        </a>
    </button>
</div>
<style>
.frisbuy-footer_button-wrapper {
    display: flex;
    justify-content: center;
}

.frisbuy-footer_button-wrapper .frisbuy-button.more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 16px;

    width: 137px;
    height: 32px;

    background: #FFFFFF;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    border: none;

    margin-top: 26px !important;
}
@media screen and (min-width: 768px) {
    .frisbuy-footer_button-wrapper .frisbuy-button.more {
        margin-top: 34px !important;
    }
}

.frisbuy-footer_button-wrapper .frisbuy-button.more a {
    color: #252B2E;

    font-family: inherit;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    white-space: nowrap;
}
</style>
*/
// const maxWidthDefault = 1350;
// const minWidthDefault = 452;

// NOTE: infinity gallery
// 7998bb35-3b49-49e6-824f-90d36e390ba1
/*
username=fortest&count=14&mode=tile&scroll_style=arrow&cols=5&cols_min=1&spacing=16&auto_load_more=1&preview=0&disable_stub=1&load_more=1&load_more_spacing=15&widget_id=8519&layout=1-4&line_mode_rows=&load_more_text=Еще&max_width=768&min_width=414&load_more_mob_spacing=15&html_title_block=<style>
@media (max-width: 1365px) {
  .frisbuy-widget {
    --frisbuy-custom-gallery-posts-margin-mob: 6px;
  }
  .frisbuy-widget .frisbuy-gallery-posts {
    width: calc(100% %2B 28px) !important;
    margin: calc(-1 * var(--frisbuy-custom-gallery-posts-margin-mob)) !important;
  }
  .frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post {
    margin: var(--frisbuy-custom-gallery-posts-margin-mob) !important;
  }
}

@media (max-width: 767px) {
  .frisbuy-widget .frisbuy-gallery-posts {
    width: calc(100% %2B 19px) !important;
  }
}
</style>
*/
// 2b7fc60c-e37e-411c-ae9a-2263a4798c92 (client)
/*
theme=kiko&username=kikocosmetics&count=32&mode=tile&scroll_style=arrow&cols=5&cols_min=1&spacing=16&auto_load_more=1&preview=0&disable_stub=1&load_more=1&load_more_spacing=15&layout=1-4&line_mode_rows=&load_more_text=Еще&max_width=768&min_width=414&load_more_mob_spacing=15&hide_sold_out_skus=1&hide_sold_out_sku_posts=1&branding_top=0&full_size_pic=0&load_more_text=Показать больше&show_report_button=1&html_title_block=<style>
@media (max-width: 1365px) {
  .frisbuy-widget {
    --frisbuy-custom-gallery-posts-margin-mob: 6px;
  }
  .frisbuy-widget .frisbuy-gallery-posts {
    width: calc(100% %2B 28px) !important;
    margin: calc(-1 * var(--frisbuy-custom-gallery-posts-margin-mob)) !important;
  }
  .frisbuy-widget .frisbuy-gallery-posts .frisbuy-gallery-post {
    margin: var(--frisbuy-custom-gallery-posts-margin-mob) !important;
  }}
@media (max-width: 767px) {
  .frisbuy-widget .frisbuy-gallery-posts {
    width: calc(100% %2B 19px) !important;  
}}
</style>&html_footer_block=<style>
.frisbuy-widget .frisbuy-footer .frisbuy-loadmore-button {
    display: flex;
    justify-content: center;
    align-items: center;

    width: fit-content;

    background: #FFFFFF;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    border: none;

    color: #252B2E;

    font-family: inherit;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    white-space: nowrap;

    padding: 9px 16px;
    margin:  calc(40px - 6px) auto 0 auto !important;
}
@media screen and (min-width: 1366px) {
    .frisbuy-footer .frisbuy-loadmore-button {
        margin: calc(48px - 6px) auto 0 auto !important;
    }
}
</style>&widget_id=9154
*/
// const maxWidthDefault = 768;
// const minWidthDefault = 414;

export default {
  mixins: [defaultGallery],

  components: { Popup },

  data() {
    return {
      canNextScroll: false,

      countOfPosts: 0,
      currentPage: 0,
      countOfPages: 0,
    };
  },

  props: ['postCount'],

  watch: {
    countOfPosts(value) {
      this.$nextTick(() => {
        if (value > 0) {
          this.countOfPages = this.getCountOfPages()
        }
      })
    },
  },

  computed: {
    isMobile() {
      return this.containerWidthPx < 752; // window width === 768;
    },

    isTablet() {
      return this.containerWidthPx < 1350; // window width === 1366;
    },

    containerItemWidth: {
      cache: false,
      get() {
        const { containerWidthPx } = this;
        const { minCols, maxCols, layout, multiline } = this.gallerySettings;
        let { maxWidth, minWidth, fixedWidth } = this.gallerySettings.postItem;
        let totalCols = minCols;

        if (fixedWidth) return `${fixedWidth}px`;

        if (this.isVerticalGallery) {
          return `${100 / (multiline || 1)}%`;
        }

        maxWidth = maxWidth || maxWidthDefault;
        minWidth = minWidth || minWidthDefault;

        if (containerWidthPx > maxWidth) {
          totalCols = maxCols;
        } else if (containerWidthPx > minWidth) {
          totalCols = 5;
          if (this.isTablet) {
            totalCols = 3;
          }
          if (this.isMobile) {
            totalCols = 2;
          }
        }

        return `${Math.floor(10000 / totalCols) / 100}%`;
      },
    },

    isShowPagination: {
      get() {
        const condition = this.countOfPages > 1 && (this.isMobile || this.isTablet);
        
        return condition;
      },
      cache: false,
    },

    isLineRowsMode: {
      cache: false,
      get() {
        return (
          this.gallerySettings.layout != 'tile' &&
          this.gallerySettings.multiline > 1 &&
          window.innerWidth < 1025 &&
          this.countOfPosts > 2
        );
      }
    }
  },

  methods: {
    getPostItemWidth(index) {
      let postContainerWidth;

      if (
        this.gallerySettings.layout == "tile" &&
        this.gallerySettings.scheme === "1-4" &&
        !(this.isMobile || this.isTablet)
      ) {
        if (!index || !((index - 11) % 18) || !(index % 18)) {
          postContainerWidth = "50%";
        } else {
          postContainerWidth = "25%";
        }
      }

      if (
        this.gallerySettings.layout == "tile" &&
        this.gallerySettings.scheme === "1-4" &&
        this.isTablet &&
        !this.isMobile
      ) {
        postContainerWidth = "25%";
      }

      if (
        this.gallerySettings.layout == "tile" &&
        this.gallerySettings.scheme === "1-4" &&
        this.isMobile
      ) {
        if (!index || index === 5 || (
          index - 5 > 0 && !((index - 5) % 9)
        )) {
          postContainerWidth = "100%";
        } else {
          postContainerWidth = "50%";
        }
      }

      if (!postContainerWidth) {
        postContainerWidth = this.containerItemWidth;
      }

      return `calc(${postContainerWidth} - ${this.containerItemMargin}px)`;
    },

    getCountOfPages() {
      const postItem = document.querySelector(".frisbuy-gallery-post");
      const postItemWidth = postItem.offsetWidth + this.containerItemMargin;
      const countOfPostsInRow = window.innerWidth / postItemWidth;
      const countOfRowsInTile = 2;
      const countOfPostsPerPage = countOfPostsInRow * countOfRowsInTile;
      
      const pagesCount = Math.ceil(this.postList.length / countOfPostsPerPage);

      return pagesCount;
    },

    galleryScrollTo(pageIdx) {
        const direction = pageIdx - this.currentPage;

        this.slideHandler(direction);
    },
    slideHandler(direction) {
      const changedPage = this.currentPage + direction;
      if (
        changedPage >= 0 && changedPage < this.countOfPages || 
        !this.isMobile && this.canNextScroll && direction > 0 ||
        !this.isMobile && this.canPrevScroll && direction < 0
      ) {
        this.currentPage = changedPage;
      }

      const scrollElement = this.widgetRefElement.querySelector('.frisbuy-scroll-wrapper');
      const widthElement = this.widgetRefElement.querySelector('.frisbuy-gallery-posts');

      this.sendAnaliticEvent(`Swipe`, { swipeType: 'arrow' });

      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );

      if (this.isVerticalGallery) {
        scrollElement.scrollBy({
          behavior: 'smooth',
          left: 0,
          top: widthElement.clientHeight * direction
        });
      } else {
        scrollElement.scrollTo({
          behavior: 'smooth',
          left: widthElement.clientWidth * changedPage,
          top: 0,
        });
      }
    },

    swipeHandler(direction) {

      // return;
      // if (gallerySettings != 'arrow' || !isMobile) return;
      // if (!isMobile) return;
      if (!this.isMobile && !this.isTablet) return;

      switch (direction) {
        case 'left':
          this.slideHandler(1);
          break;
        case 'right':
          this.slideHandler(-1);
          break;
      }
    },
  },

  created() {
    this.countOfPosts = this.postList.length;
  },

  mounted() {
    /*
      NOTE: This func for fix pagination and render two lines on tablet or mobile
    */
    this.$nextTick(() => this.resizeHandler());
  }
};
</script>
